import { render, staticRenderFns } from "./OrderInformation.vue?vue&type=template&id=d2a8b13a&scoped=true&"
import script from "./OrderInformation.vue?vue&type=script&lang=js&"
export * from "./OrderInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2a8b13a",
  null
  
)

export default component.exports